var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"EcommerceEnterpriseTotal"}},[_c('img',{attrs:{"src":require("@/assets/img/Group3862.png"),"alt":""}}),_c('div',[_c('div',{staticClass:"num"},[_c('span',[_vm._v(_vm._s(_vm.num))])]),_c('div',{staticClass:"title"},[_vm._v("电商企业总数")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }